import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Wrapper = styled.div`
  ${({ isDisabled }) => isDisabled && 'cursor: not-allowed'};
`;
Wrapper.displayName = 'Wrapper';
